module.exports = __webpack_public_path__ + "static/media/9DESA36.ec89e655.jpg";